import { render, staticRenderFns } from "./PreviousDayTimeToQualityControlMessage.vue?vue&type=template&id=2fbdce69&scoped=true&"
import script from "./PreviousDayTimeToQualityControlMessage.vue?vue&type=script&lang=js&"
export * from "./PreviousDayTimeToQualityControlMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbdce69",
  null
  
)

export default component.exports